module.exports = __webpack_public_path__ + "img/36_60.9270608f.png";